export const FIELD_COMPONENT_TYPE = "xField";
export const COLLECTION_COMPONENT_TYPE = "xCollection";
export const TEXT_LIST_COMPONENT_TYPE = 'xTextList';
export const OPTIONAL_COMPONENT_TYPE = 'xOptional';